var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60565 2.47964C7.21733 1.3922 8.783 1.3922 9.39469 2.47964L13.8589 10.4161C14.4589 11.4826 13.6881 12.8005 12.4644 12.8005H3.53592C2.3122 12.8005 1.54146 11.4826 2.1414 10.4161L6.60565 2.47964ZM8.8001 10.4006C8.8001 10.8424 8.44193 11.2006 8.0001 11.2006C7.55827 11.2006 7.2001 10.8424 7.2001 10.4006C7.2001 9.95876 7.55827 9.60059 8.0001 9.60059C8.44193 9.60059 8.8001 9.95876 8.8001 10.4006ZM8.0001 4.00059C7.55827 4.00059 7.2001 4.35876 7.2001 4.80059V7.20059C7.2001 7.64241 7.55827 8.00059 8.0001 8.00059C8.44192 8.00059 8.8001 7.64241 8.8001 7.20059V4.80059C8.8001 4.35876 8.44192 4.00059 8.0001 4.00059Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.af870bbb0d0a96f2dc52b610ce989f5e.svg";
export { ForwardRef as ReactComponent };